// src/App.tsx
import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { routes } from './globalConfig/router';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {routes.map(r => (
            <Route key={r.path} path={r.path} element={r.component} />
          ))}
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;

